module.exports = __webpack_public_path__ + "img/11_45.f77ca42a.png";